






























import { Vue, Component, Prop } from 'vue-property-decorator'
import ExpandablePreview from 'components/ExpandablePreview.vue'
import PersonAvatar from 'components/account/PersonAvatar.vue'
import MarkdownViewer from 'components/MarkdownViewer.vue'
import { Item } from 'src/graphql/types'

@Component({
  components: {
    ExpandablePreview,
    PersonAvatar,
    MarkdownViewer
  }
})
export default class AttendeeItemTopic extends Vue {

  @Prop()
  readonly slide!: Json

  get info () {
    return this.slide.topic?.data?.info?.text?.getText()?.toString().trim()
  }

  get files () {
    return (Object.values(this.slide.topic?.data?.info?.files || {}) as Json[]).filter(x => x.id && x.id !== this.slide.topic?.data?.info?.coverImageId && !x.hide && !x.deleted).sort((a, b) => a.sort - b.sort)
  }

  urlFileName (url: string) {
    return url.split('/').pop() || 'file'
  }

  download (url: string, name: string) {
    const a = document.createElement('a')
    a.style.display = 'none';
    document.body.appendChild(a)
    a.href = url
    a.setAttribute('download', name || this.urlFileName(url))
    a.setAttribute('target', '_blank')
    a.click()
    document.body.removeChild(a)
  }
}
